import { Component, Input, OnInit } from '@angular/core'
//import dotsSvg from 'src/assets/dots.svg'

@Component({
  selector: 'mu-dots',
  styleUrls: ['./mu-dots.component.scss'],
  templateUrl: './mu-dots.component.html',
})
export class MuDotsComponent implements OnInit {
  @Input() direction: 'horizontal' | 'vertical'
  src: string = 'assets/dots.svg'

  ngOnInit() {}
}
